import { BaseDto } from "./base-dto";
export class usuario extends BaseDto {
  public email!: string;
  public contra!: string;
  public nombre!: string;
  public telefono!: string;
  public cargo!: string;
  public id_rol!: string;
}
